<template>
  <QuestionBase :errors="[...serverErrors, ...jsErrors, ...errorsPost]"
                :question="question"
                :valid="data !== null">
    <InputRadio v-model="data"
                :args="args"
                :db="db"
                :no-save="noSave"
                :options="booleanYesNo"
                :skipped="skipped"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {willRelationshipHelpers} from "../../../../../fieldsets/will/helpers/willRelationshipHelpers";
import {willPeopleHelpers} from "../../../../../fieldsets/will/helpers/willPeopleHelpers";
import {questionLoadHelpers} from "../../../../helpers/questionLoadHelpers";
import {general} from "../../../../options/general";
import QuestionBase from "../../../../QuestionBase";
import InputRadio from "../../../../inputs/InputRadio";
import {personHelpers} from "@/mixins/personHelpers";
import {textHelpers} from "@/mixins/textHelpers";

export default {
  name: 'RecipientsBackupYN',
  mixins: [
    general,
    questionLoadHelpers,
    willPeopleHelpers,
    willRelationshipHelpers,
    personHelpers,
    textHelpers
  ],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    location: {
      type: String,
      required: true
    },
    giftDetails: {
      type: Object,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    question() {
      return {
        title: this.giftDetails.recipients.length ? `Would you like to name substitute recipients in-case ${this.listPeopleAddressDob({
          people: this.giftDetails.recipients,
          noDob: true,
          firstName: true
        })} ${this.hasHave({list: this.giftDetails.recipients})} passed away before you?` : `Would you like to name substitute recipients in-case the above recipients have passed away before you?`
        ,
        subTitle: this.giftDetails.recipients.length ? `If you do not name substitute recipients and ${this.listPeopleAddressDob({
          people: this.giftDetails.recipients,
          noDob: true,
          firstName: true
        })} ${this.hasHave({list: this.giftDetails.recipients})} passed away before you, the gift will 'fail' and instead be distributed with the rest of your estate.` : `If you do not name substitute recipients and those named above have passed away before you, the gift will 'fail' and instead be distributed with the rest of your estate.`,
        tip: null,
      }
    },
  },
  data() {
    return {
      db: {
        saveLocation: 'product_will_data',
        saveField: `${this.location}${this.index}RecipientsBackupYN`,
        formPath: `data.${this.location}.details.gifts.${this.index}.backupRecipientsYN`,
        jsonSaveField: 'backupRecipientsYN'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
